// src/firebase.js
if (
  typeof window !== "undefined" &&
  (location.hostname === "localhost" || location.hostname === "127.0.0.1")
) {
  // Use a fixed token so you don't have to copy/paste every run
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = "3C4E9765-1796-4E86-AAE9-F7B12584A5E7"
}

import { initializeApp } from "firebase/app";
import { getAuth, signOut, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore, collection, doc, getDoc } from "firebase/firestore";
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyCGD9J8b2AwfHe-g9P5EjKUW6FAc_avtUg",
  authDomain: "match-reporting.firebaseapp.com",
  projectId: "match-reporting",
  storageBucket: "match-reporting.firebasestorage.app",
  messagingSenderId: "623433347512",
  appId: "1:623433347512:web:4ab30af902b0890812df4d",
  measurementId: "G-Z4PVFN39ES"
};

const app = initializeApp(firebaseConfig);

window.FIREBASE_APPCHECK_DEBUG_TOKEN = "3C4E9765-1796-4E86-AAE9-F7B12584A5E7"

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LeibNArAAAAAGUI5IbqyYYLOvMKm2tbRhxk3v1r'),
  isTokenAutoRefreshEnabled: true, // keep token fresh
});

try {
  const t = await getToken(appCheck, true);
  console.log("AppCheck OK:", t.token.slice(0, 12) + "…");
} catch (e) {
  console.warn("AppCheck token (non-fatal):", e?.message || e);
}

const auth = getAuth(app);
const functions = getFunctions(app, "us-central1");
const db = getFirestore(app);

const matchreportsColRef = collection(db, "matchreports");
const misconductColRef = collection(db, "misconduct");
const gamescheduleColRef = collection(db, "gameschedule");
const leaguesColRef = collection(db, "leagues");
const listMisconductColRef = collection(db, "listMisconduct");
const usersColRef = collection(db, "users");
const ADMINsettingsColRef = collection(db, "ADMINsettings");
const refereesColRef = collection(db, "referees");
const genderagesColRef = collection(db,"genderages");

// Set session persistence to local (ensure persistence across sessions)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence is set to local.");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error.message);
  });

console.log("Firebase initialized:", {
  projectId: firebaseConfig.projectId,
  auth: !!auth,
  db: !!db,
  functions: !!functions,
  functionsRegion: "us-central1"
});

export {
  app, appCheck, auth, functions,
  db, doc, getDoc,
  matchreportsColRef, misconductColRef, gamescheduleColRef,
  leaguesColRef, listMisconductColRef, usersColRef,
  refereesColRef, genderagesColRef, ADMINsettingsColRef,
  signOut
 };